import { Tooltip } from 'antd'
import CustomTag from 'components/CustomTag'
import { FilterText } from 'components/FilterDiv'
import Pagination from 'components/Pagination'
import SearchInput from 'components/SearchInput'
import { RowNumberData } from 'components/TableStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import CourseFilter from 'modules/Courses/Partials/CourseFilter'
import CoursesStatus from 'modules/Courses/Partials/CoursesStatus'
import ActionMenu from 'modules/Courses/Partials/CoursesTable/ActionMenu'
import { ContentCenterDiv, SkillRow } from 'modules/Courses/Style/style'
import {
  NavWrapper,
  TableTop,
} from 'modules/Students/Partials/StudentsInfoTable/Style/style'
import React, { useCallback, useState } from 'react'
const CoursesInfoTable = ({
  degreeList,
  onEdit,
  onDelete,
  loading,
  setPage,
  page,
  degreeFilterList,
  onPageChange,
  search,
  setSearch,
  onActivate,
  duration,
  setDuration,
  setExamType,
  setDegreeFilter,
  listOfStudentSkills,
  setSkillList,
  setStatusFilter,
  setSort,
  sortBy,
  setOrderBy,
  orderBy,
  setIsEditable,
  skillListData,
  getSkillList,
  scrollToAppContainer,
  domainFilter,
  setDomainFilter,
  setSpecializationFilter,
  cruds,
}) => {
  const [selectEdit, setSelectEdit] = useState()

  const editCourse = (event, param) => {
    setSelectEdit(param)
    setIsEditable(param?.previousTransactions)
  }
  const editClicked = () => {
    onEdit(selectEdit)
  }
  const deletedClicked = () => {
    onDelete(selectEdit)
  }
  const setStatusIsActive = () => {
    onActivate(selectEdit)
  }

  const delaySaveToDb = useCallback(
    debounce(text => {
      setPage(0)
      // Only trigger the API call, don't update search state here
      // since it's already updated immediately in the input onChange
    }, 1000),
    []
  )
  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  const showText = () => {
    const currentPage = page
    const currentCount = currentPage * 10
    if (degreeList?.count === 0) {
      return 'Showing ' + degreeList?.count + ' of ' + degreeList?.count
    } else if (currentPage === degreeList?.totalPage) {
      return 'Showing ' + degreeList?.count + ' of ' + degreeList?.count
    } else {
      return 'Showing ' + currentCount + ' of ' + degreeList?.count
    }
  }

  const sortFilter = sort => {
    let sortOrder = orderBy
    if (sort === sortBy) {
      if (sortOrder === 'asc') {
        sortOrder = 'desc'
      } else if (sortOrder === 'desc') {
        sortOrder = ''
        sort = ''
      } else {
        sortOrder = 'asc'
      }
    } else {
      sortOrder = 'asc'
    }
    setOrderBy(sortOrder)
    setSort(sort)
  }

  const columns = [
    {
      title: 'DEGREE',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('degree')
          },
        }
      },
      render: (text, item) => (
        <RowNumberData>
          {item?.degreeStreamMap?.degree?.name}
          {' - '}
          {item?.degreeStreamMap?.degree?.shortForm}
        </RowNumberData>
      ),
    },
    {
      title: 'DEPARTMENT',
      dataIndex: 'department',
      key: 'department',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('stream')
          },
        }
      },
      render: (text, item) => (
        <RowNumberData>{item?.degreeStreamMap?.stream?.name}</RowNumberData>
      ),
    },
    {
      title: 'Specialization',
      dataIndex: 'specialization',
      key: 'specialization',
      // sorter: true,
      // sortDirections: ['ascend', 'descend'],
      // onHeaderCell: column => {
      //   return {
      //     onClick: () => {
      //       sortFilter('stream')
      //     },
      //   }
      // },
      render: (text, item) => (
        <Tooltip
          title={item?.courseSpecialisationMap
            .map(spec => spec?.specialisation?.name)
            .join(', ')}
        >
          <SkillRow>
            {item?.courseSpecialisationMap?.length > 1 ? (
              <>
                <CustomTag
                  message={
                    item?.courseSpecialisationMap[0]?.specialisation?.name
                  }
                  bordered={true}
                  background="#F2F3F5"
                  colorType="#808697"
                  border="#F2F3F5"
                />
                <CustomTag
                  message={`+${item?.courseSpecialisationMap?.length - 1}`}
                  bordered={true}
                  background="#F2F3F5"
                  colorType="#808697"
                  border="#F2F3F5"
                />
              </>
            ) : item?.courseSpecialisationMap?.length === 1 ? (
              <CustomTag
                message={item?.courseSpecialisationMap[0]?.specialisation?.name}
                bordered={true}
                background="#F2F3F5"
                colorType="#808697"
                border="#F2F3F5"
              />
            ) : (
              <RowNumberData>-</RowNumberData>
            )}
          </SkillRow>
        </Tooltip>
      ),
    },
    {
      title: 'DOMAIN',
      dataIndex: 'domain',
      key: 'domain',
      sorter: true,
      sortDirections: ['ascend', 'descend'],

      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('domain')
          },
        }
      },
      render: (text, item) => (
        <RowNumberData>
          {item?.degreeStreamMap?.degree?.domain?.name}
        </RowNumberData>
      ),
    },
    {
      title: 'DURATION',
      dataIndex: 'duration',
      key: 'duration',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('duration')
          },
        }
      },
      render: (text, item) => (
        <RowNumberData>{item?.degreeStreamMap?.duration || '-'}</RowNumberData>
      ),
    },

    {
      title: 'EXAM TYPE',
      dataIndex: 'examType',
      key: 'examType',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('examType')
          },
        }
      },
      render: (text, item) => (
        <RowNumberData>{item?.degreeStreamMap?.examType || '-'}</RowNumberData>
      ),
    },

    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      render: (text, item) => <CoursesStatus status={item?.status} />,
    },
    {
      title: 'ACTION',
      dataIndex: '_id',
      width: 100,
      hidden:
        !cruds?.includes('ACTIVE/INACTIVE') &&
        !cruds?.includes('EDIT') &&
        !cruds?.includes('DELETE'),
      render: (id, item) => (
        <ActionMenu
          item={item}
          editCourse={editCourse}
          editClicked={editClicked}
          deletedClicked={deletedClicked}
          setStatusIsActive={setStatusIsActive}
          isStudentLinked={item?.isStudentLinked}
          cruds={cruds}
        />
      ),
    },
  ]?.filter(item => !item?.hidden)
  return (
    <NavWrapper column id="parent-container">
      <TableTop centerVertically>
        <SearchInput
          width={'25%'}
          placeholder="Search by degree/department"
          bordered={false}
          searchValue={search}
          setSearchValue={text => {
            setSearch(text) // Update immediately for smooth typing
            delaySaveToDb(text) // Debounced API call
          }}
        />
        <CourseFilter
          degreeList={degreeFilterList}
          duration={duration}
          setDuration={setDuration}
          setExamType={setExamType}
          setDegreeFilter={setDegreeFilter}
          setSkillList={setSkillList}
          listOfStudentSkills={listOfStudentSkills}
          setStatusFilter={setStatusFilter}
          skillListData={skillListData}
          getSkillList={getSkillList}
          setPage={setPage}
          domainFilter={domainFilter}
          setDomainFilter={setDomainFilter}
          setSpecializationFilter={setSpecializationFilter}
        />
        <FilterText>{showText()}</FilterText>
      </TableTop>
      <StyledTable
        scrollToAppContainer={scrollToAppContainer}
        pagination={false}
        columns={columns}
        dataSource={degreeList?.courses}
        loading={loading}
      />
      {!loading && (
        <ContentCenterDiv>
          <Pagination
            current={page}
            total={degreeList?.count}
            onChange={onPageChange}
            defaultCurrent={1}
          />
        </ContentCenterDiv>
      )}
    </NavWrapper>
  )
}

export default CoursesInfoTable
